import React, { useEffect, useState } from "react";
import { Box, Typography, Button, useMediaQuery, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import Arrows from "../carouselComponent/arrows";
import Carousel from "../carouselComponent/carousel";

const loanProfiles = [
  {
    title: "Personal Loan for Doctor",
    image: IMAGES.doctor,
  },
  {
    title: "Personal Loan for Businessman",
    image: IMAGES.businessMan,
  },
  {
    title: "Personal Loan for Businessman",
    image: IMAGES.businessMan,
  },
  {
    title: "Personal Loan for Businessman",
    image: IMAGES.businessMan,
  },
  {
    title: "Personal Loan for Businessman",
    image: IMAGES.businessMan,
  },
  // Add more profiles as needed
];

const CareerLoanCarousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Grid container sx={{ p: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: { xs: "row", md: "column" },
            justifyContent: {
              xs: "space-between",
            },
            mb: 4,
          }}
        >
          <Box display={"flex"}>
            <Box
              width={10}
              sx={{
                background: "linear-gradient(to bottom, #00F200, #ffffff)", // Gradient from top to bottom
                borderRadius: "10px 10px 0 0", // Rounded top corners
                height: {
                  md: 200,
                  xs: 100,
                },
              }}
            ></Box>

            <Box px={2}>
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                color={WEB_COLORS.darkTeal}
                sx={{
                  fontSize: {
                    xs: 20,
                    md: 40,
                  },
                }}
              >
                Tailored Loans.
                <br /> Trusted Solutions.
              </Typography>
              <Typography
                color={"#3F3F3FCC"}
                fontWeight={400}
                sx={{
                  fontSize: {
                    xs: 12,
                    md: 18,
                  },
                }}
              >
                Get quick personal loans based on your career profile.
              </Typography>
            </Box>
          </Box>
          <Box sx={{ ml: { md: 4, xs: 0 } }}>
            <Arrows
              isPrevActive={activeIndex === 0 ? false : true}
              isNextActive={
                activeIndex === loanProfiles?.length - 1 ? false : true
              }
              prevSlide={() =>
                setActiveIndex(activeIndex < 1 ? 0 : activeIndex - 1)
              }
              nextSlide={() =>
                setActiveIndex(
                  activeIndex === loanProfiles?.length - 1
                    ? loanProfiles?.length - 1
                    : activeIndex + 1
                )
              }
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Carousel
            activeIndex={activeIndex}
            carouselSlides={loanProfiles}
            content={true}
            showImages={true}
          >
            <Button variant="text" fontWeight={400} color="success">
              <Typography sx={{ fontSize: { xs: 14, md: 16 } }}>
                Apply Now ➔
              </Typography>
            </Button>
          </Carousel>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CareerLoanCarousel;
